/**
 * IndustryService
 * Service for Industry entity operations
 * Route: api/industries
 */
import { CrudService } from '../base/CrudService';
/**
 * IndustryService
 * Handles industry classification CRUD operations
 */
export class IndustryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? IndustryService.DEFAULT_SERVICE_PATH,
            basePath: IndustryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
IndustryService.DEFAULT_SERVICE_PATH = 'suppliers';
IndustryService.BASE_PATH = 'api/industries';
//# sourceMappingURL=IndustryService.js.map